module.exports = __webpack_public_path__ + "img/orange-clock.349fb8ab.svg";